import React, { useState, useEffect } from "react";
import EnviarImagem from "./EnviarImagem";
import moment from "moment-timezone";
import { cpfMask } from "../services/funcoesAuxiliares";
import InputMask from "react-input-mask";
const { criarCarteiras, uploadImage, apiUrl } = require("../services/requests");

const CriarCarteira = ({getCarteiras}) => {

  const [nome, setNome] = useState("");
  const [instituicaoEnsino, setInstituicaoEnsino] = useState("");
  const [curso, setCurso] = useState("");
  const [imagemInicial] = useState(`${apiUrl}/images/0.png`);
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [imagem, setImagem] = useState("");
  const [error, setError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const criarCarteira = async (event) => {
    event.preventDefault();

    if (isButtonDisabled || isSubmitting) return;
    setIsSubmitting(true);

    try {
      const endpoint = "/carteiras";
      const upload = "/upload-image";

      if (imagem !== "") {
        const formData = new FormData();
        formData.append("image", imagem);

        await uploadImage(upload, formData);
      }

      await criarCarteiras(endpoint, {
        foto: imagem === "" ? imagemInicial : `${apiUrl}/images/${imagem.name}`,
        nome,
        instituicaoEnsino,
        curso,
        cpf,
        rg,
        dataNascimento,
        email,
        telefone,
        observacao: "",
      });

      getCarteiras("gestores", null, 1, 10);
      setError(false);
      alert("Carteira Criada Com Sucesso!");
      setNome("");
      setInstituicaoEnsino("");
      setCurso("");
      setCpf("");
      setRg("");
      setDataNascimento("");
      setEmail("");
      setTelefone("");
    } catch (error) {
      if (error.request.status === 409) {
        setError(true);
      }
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const formData = [nome, instituicaoEnsino, curso, cpf, rg, dataNascimento];

    const isValidFormData = formData.every((value) => value !== "");
    setIsButtonDisabled(!isValidFormData);
  }, [nome, instituicaoEnsino, curso, cpf, rg, dataNascimento]);

  return (
    <div className="flex items-center justify-around rounded-lg m-2 p-2 shadow-md bg-[#aac5fc]">
      <div className="max-w-xs max-h-44 mx-2 rounded-lg mt-8">
        <EnviarImagem img={imagem} setImg={setImagem} />
      </div>
      <div className="flex flex-col w-3/5 mx-4">
        <input
          value={nome}
          id="nome"
          type="text"
          placeholder="NOME"
          onChange={(e) => setNome(e.target.value.toUpperCase())}
          className="m-1 p-1 rounded border-none font-bold"
        />
        <input
          id="InstEnsino"
          placeholder="INSTITUIÇÃO DE ENSINO"
          value={instituicaoEnsino}
          type="text"
          onChange={(e) => setInstituicaoEnsino(e.target.value.toUpperCase())}
          className="m-1 p-1 rounded border-none font-bold"
        />
        <input
          id="Curso"
          placeholder="CURSO"
          value={curso}
          type="text"
          onChange={(e) => setCurso(e.target.value.toUpperCase())}
          className="m-1 p-1 rounded border-none font-bold"
        />
        <div className="flex w-full text-sm font-bold">
          <input
            id="cpf"
            placeholder="CPF"
            value={cpf}
            type="text"
            onChange={(e) => setCpf(cpfMask(e.target.value))}
            className="font-bold w-full m-1 p-1 border-none rounded"
          />
        </div>
        <div className="flex w-full text-sm font-bold">
          <input
            id="RG"
            placeholder="RG"
            type="text"
            value={rg}
            onChange={(e) => setRg(e.target.value)}
            className="font-bold w-full m-1 p-1 border-none rounded"
          />

          <InputMask
            mask="99/99/9999"
            id="DataNascimento"
            placeholder="DATA DE NASCIMENTO"
            type="text"
            value={dataNascimento}
            onChange={(e) => setDataNascimento(e.target.value)}
            className="font-bold w-full m-1 p-1 border-none rounded"
          />
        </div>
      </div>
      <div className="flex flex-col mx-2">
        <a
          className="no-underline flex items-center justify-center rounded-lg text-xl bg-green-600 text-white font-league-gothic border-none cursor-pointer text-center box-border mb-4 w-24"
          href="https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp"
          target="_blank"
          rel="noreferrer"
        >
          CPF
        </a>
        {error ? <p className="text-red-500">{"CPF existente"}</p> : null}
        <button
          type="submit"
          className="flex items-center justify-center rounded-lg text-xl bg-blue-900 text-white font-league-gothic border-none text-center box-border mb-1 w-24 disabled:opacity-50"
          disabled={isButtonDisabled || isSubmitting}
          onClick={(event) => criarCarteira(event)}
        >
          CONFIRMAR
        </button>
      </div>
    </div>
  );
};

export default CriarCarteira;